export const CANONICAL_APP_ORIGIN = "https://teleportapp.sg";
const LEGACY_IOS_APP_OPEN_ATTEMPT_PARAM = "open_app";

export function buildCanonicalAppUrl(pathname, search = "") {
  const url = new URL(`${pathname}${search}`, CANONICAL_APP_ORIGIN);
  url.searchParams.delete(LEGACY_IOS_APP_OPEN_ATTEMPT_PARAM);
  return url.toString();
}

export function setAppleSmartBanner(publicUrl) {
  let smartBanner = document.querySelector('meta[name="apple-itunes-app"]');
  if (!smartBanner) {
    smartBanner = document.createElement("meta");
    smartBanner.setAttribute("name", "apple-itunes-app");
    document.head.appendChild(smartBanner);
  }
  smartBanner.setAttribute(
    "content",
    `app-id=6756201717, app-argument=${publicUrl}`,
  );
}
